// extracted by mini-css-extract-plugin
export var activityContainer = "_mt-0";
export var typingIndicatorContainer = "_mt-1";
export var typingIndicatorDot = "_mt-2";
export var wave = "_mt-3";